import { cn } from '@/lib/cn'
import { athleteColor } from '@/components/profile/profileUtils'

export interface AthleteDotProps {
  color: string
  className?: string
}

/**
 * Athlete's own colour (from `Athlete.color`), used for compare views and the switcher. Seeded
 * defaults resolve to the athlete tokens so the switcher, avatars and Compare agree.
 */
export function AthleteDot({ color, className }: AthleteDotProps) {
  return (
    <span
      className={cn('inline-block size-2.5 shrink-0 rounded-full', className)}
      style={{ backgroundColor: athleteColor(color) }}
      aria-hidden="true"
    />
  )
}
